import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { isArray } from 'lodash';
import { secondsToMinutesAndSeconds } from 'flow/utils/date-time-utils';
export var QUEUE_SERVICE_LEVELS_KEY = 'QUEUE_SERVICE_LEVELS';
export var CHANNEL_SERVICE_LEVELS_KEY = 'CHANNEL_SERVICE_LEVELS';
var oneMinute = 60;
var twoMinutes = 120;
export var getFormattedServiceLevel = function getFormattedServiceLevel(serviceLevel, i18next) {
  var _secondsToMinutesAndS = secondsToMinutesAndSeconds(serviceLevel),
    m = _secondsToMinutesAndS.m,
    s = _secondsToMinutesAndS.s;
  var min = i18next.t('duration.min');
  var sec = i18next.t('duration.sec');
  var formattedServiceLevel = '';
  if (serviceLevel < 0) {
    formattedServiceLevel = '';
  } else if (m && s) {
    formattedServiceLevel = "".concat(m, " ").concat(min, ", ").concat(s, " ").concat(sec);
  } else if (m) {
    formattedServiceLevel = "".concat(m, " ").concat(min);
  } else if (s) {
    formattedServiceLevel = "".concat(s, " ").concat(sec);
  } else {
    formattedServiceLevel = "0 ".concat(min);
  }
  return formattedServiceLevel;
};
export var getServiceLevelsForQueue = function getServiceLevelsForQueue(queueId) {
  return getServiceLevels(QUEUE_SERVICE_LEVELS_KEY, queueId);
};
export var setServiceLevelsForQueue = function setServiceLevelsForQueue(queueId, serviceLevels) {
  return setServiceLevels(QUEUE_SERVICE_LEVELS_KEY, queueId, serviceLevels);
};

// Setting custom service levels for channels are not yet implemented so
// getServiceLevelsForChannel and setServiceLevelsForChannel are not used.
// Remove this comment when we implement it for channels.
export var getServiceLevelsForChannel = function getServiceLevelsForChannel(channelId) {
  return getServiceLevels(CHANNEL_SERVICE_LEVELS_KEY, channelId);
};
export var setServiceLevelsForChannel = function setServiceLevelsForChannel(channelId, serviceLevels) {
  return setServiceLevels(CHANNEL_SERVICE_LEVELS_KEY, channelId, serviceLevels);
};
export var getServiceLevels = function getServiceLevels(key, id) {
  if (!key || !id) {
    return [oneMinute, twoMinutes];
  }
  var allServiceLevels = JSON.parse(wrappedLocalStorage.getItem(key)) || {};
  var serviceLevels = allServiceLevels[id] || [];
  var level1 = isNaN(serviceLevels[0]) ? oneMinute : serviceLevels[0];
  var level2 = isNaN(serviceLevels[1]) ? twoMinutes : serviceLevels[1];
  return [level1, level2];
};
export var setServiceLevels = function setServiceLevels(key, id, serviceLevels) {
  if (!key || !id) {
    return;
  }
  if (isArray(serviceLevels) && !serviceLevels.some(function (level) {
    return isNaN(level);
  })) {
    var allServiceLevels = JSON.parse(wrappedLocalStorage.getItem(key)) || {};
    var updatedServiceLevels = _objectSpread(_objectSpread({}, allServiceLevels), {}, _defineProperty({}, id, serviceLevels));
    wrappedLocalStorage.setItem(key, JSON.stringify(updatedServiceLevels));
  }
};